module.exports = __webpack_public_path__ + "img/btn_phone_pop@3x.ea01bb75.png";